import * as React from 'react';

import { Box } from '@mui/material';

import UnattachedEventReportsGroup from './UnattachedEventReportsGroup';

import { useUnattachedEventReportsData } from '../../core/context/UnattachedEventReportsContext';

function UnattachedEventReportsGroupedList() {
  const { groupedEventReports } = useUnattachedEventReportsData();

  return (
    <Box>
      {Object.keys(groupedEventReports).map((key) => (
        <UnattachedEventReportsGroup
          key={key}
          containerId={key}
          eventReports={groupedEventReports[key]}
        />
      ))}
    </Box>
  );
}

export default UnattachedEventReportsGroupedList;
